import React from 'react';
import { Svg, Circle, G, Path, Rect } from 'react-native-svg';

const CalendarIcon = () => (
  <Svg height="24" width="24" viewBox="0 0 24 24">
    <G fill="none" fillRule="evenodd">
      <Path d="M0 0h24v24H0z" />
      <Rect
        height="16"
        width="18"
        rx="2"
        stroke="#696969"
        strokeWidth="2"
        x="3"
        y="5"
      />
      <Path
        d="M7 3v3M17 3v3"
        stroke="#696969"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <Path d="M3 9h18" stroke="#696969" strokeWidth="2" />
      <Circle cx="7" cy="13" fill="#696969" fillRule="nonzero" r="1" />
      <Circle cx="12" cy="13" fill="#696969" fillRule="nonzero" r="1" />
      <Circle cx="17" cy="18" fill="#696969" fillRule="nonzero" r="1" />
      <Circle cx="12" cy="18" fill="#696969" fillRule="nonzero" r="1" />
      <Circle cx="7" cy="18" fill="#696969" fillRule="nonzero" r="1" />
      <Circle cx="17" cy="13" fill="#696969" fillRule="nonzero" r="2" />
    </G>
  </Svg>
);

export default CalendarIcon;
